import React from "react";
import { Mutation, Query } from "react-apollo";
import queries from "../../../queries";
import ImageUploader from "../../uploaders/ImageUploader";
import _ from "lodash";
import { FormattedMessage } from "react-intl";
import fieldCreationDialog from "../../dialogs/FieldCreationDialog";
import FieldEditor from "./FieldEditor";

class JackpotCellEditor extends React.Component {
  state = {
    box_uri: '',
    lam_uri: '',
    box_left: 0,
    box_top: 0,
    box_width: 100,
    box_height: 100,
  };

  componentDidUpdate(prevProps) {
    const { jackpotCell } = _.get(this.props, 'data', {});
  
    if (
      jackpotCell &&
      !this.state.isChange &&
      (
        jackpotCell.box_left !== this.state.box_left ||
        jackpotCell.box_top !== this.state.box_top ||
        jackpotCell.box_width !== this.state.box_width ||
        jackpotCell.box_height !== this.state.box_height
      )
    ) {
      this.setState({
        box_uri: jackpotCell.box_uri,
        lam_uri: jackpotCell.lam_uri,
        cell_id: jackpotCell.id,
        box_left: jackpotCell.box_left,
        box_top: jackpotCell.box_top,
        box_width: jackpotCell.box_width,
        box_height: jackpotCell.box_height,
      });
    }
  }  
  
  render() {
    const { cell, language, screenType } = this.props;

    if (!cell) return null;

    return (
      <Query query={queries.cells.jackpot.get} variables={{ id: cell.id, screen_type_id: screenType.id }}>
        {({ loading, error, data }) => {
          if (loading) return null;
          if (error) return `Error!: ${error}`;

          const { jackpotCell } = data;

          if (!jackpotCell) return null;    
          
          const { imageUriValue, mutation, mutationInputFromUri } = !!language
            ? {
                imageUriValue: (_.filter(jackpotCell.i18n, { language_code: language.code })[0] || {}).box_uri,
                lamValue: (_.filter(jackpotCell.i18n, { language_code: language.code })[0] || {}).lam_uri,
                mutation: queries.cells.i18n.update,
                mutationInputFromUri: () => ({
                  cell_id: cell.id,
                  language_code: language.code,
                }),
              }
            : {
                imageUriValue: jackpotCell.box_uri,
                lamValue: jackpotCell.lam_uri,
                mutation: queries.cells.jackpot.update,
                mutationInputFromUri: () => ({
                    id: cell.id,
                }),
            };

          return (
            <Mutation
              mutation={mutation}
              refetchQueries={() => [{ query: queries.cells.jackpot.get, variables: { id: cell.id } }]}
              onCompleted={this.handleMutationCompleted}
              onError={this.handleMutationError}
            >
              {(mutationFct) => (
                <>
                  <ImageUploader
                    value={imageUriValue}
                    onUpload={(jackpot) => {
                        console.log('jackpot', jackpot);
                        this.setState({ ...this.state, box_uri: jackpot, isChange: true});
                    }}
                  />
                  <br/>
                  <ImageUploader
                    value={imageUriValue}
                    onUpload={(lam) => {
                        console.log('lam', lam);
                      this.setState({ ...this.state, lam_uri: lam, isChange: true });
                    }}
                  />
                  <br />
                  <label slot="box_left">
                    <FormattedMessage id={"cell.jackpot.box_left"} />
                  </label>
                  <input
                    type="number"
                    name="box_left"
                    onChange={(e)=>{this.setState({ box_left: parseInt(e.target.value) })}}
                    value={this.state.box_left}
                    min={0}
                     max={100}
                  >
                  </input>
                  <br />
                  <label slot="box_top">
                    <FormattedMessage id={"cell.jackpot.box_top"} />
                  </label>
                  <input
                    type="number"
                    name="box_top"
                    onChange={(e)=>{this.setState({ box_top: parseInt(e.target.value) })}}
                    value={this.state.box_top}
                    min={0}
                     max={100}
                  >
                  </input>
                  <br />
                  <label slot="box_width">
                    <FormattedMessage id={"cell.jackpot.box_width"} />
                  </label>
                  <input
                    type="number"
                    name="box_width"
                    onChange={(e)=>{this.setState({ box_width: parseInt(e.target.value) })}}
                    value={this.state.box_width}
                    min={0}
                     max={100}
                  >
                  </input>
                  <br />
                  <label slot="box_height">
                    <FormattedMessage id={"cell.jackpot.box_height"} />
                  </label>
                  <input
                    type="number"
                    name="box_height"
                    onChange={(e)=>{this.setState({ box_height: parseInt(e.target.value) })}}
                    value={this.state.box_height}
                    min={0}
                     max={100}
                  >
                  </input>
                  <Mutation
                            mutation={queries.form_fields.create}
                            refetchQueries={() => [{ query: queries.cells.jackpot.get, variables: {id: jackpotCell.id} }]}
                          >
                          {(createField) => (
                            <>
                            <br/>
                            <br/>
                              {
                                jackpotCell.fields.map((field)=>{
                                  return(
                                    <div key={field.id} className={'tsk-input-line'}>
                                      <FieldEditor field={field} cell={cell} screenType={screenType} language={language}/>
                                    </div>
                                    )
                                })
                              }
                              <br/>
                              <button className={'tsk-button'} onClick={async () => {
                              const newField = await fieldCreationDialog({cell_id: cell.id});
                              await createField({variables: {input: newField}});
                            }}>
                              <FormattedMessage id={'common.button.new'}/>
                              </button>
                              </>
                          )}
                  </Mutation>
                  <br/>
                  <br/>
                  <button
                            className={'tsk-button'}
                            onClick={() => {

                            const data = {
                                id: cell.id,
                                box_left: parseInt(this.state.box_left),
                                box_top: parseInt(this.state.box_top),
                                box_width: parseInt(this.state.box_width),
                                box_height: parseInt(this.state.box_height),
                                box_uri: this.state.box_uri,
                                lam_uri: this.state.lam_uri,
                            };
                            mutationFct({variables: {input: data}})
                          }}>
                            <FormattedMessage id={'common.button.submit'}/>
                    </button>
                </>
              )}
            </Mutation>
          );
        }}
      </Query>
    );
  }
}

export default JackpotCellEditor;
